import React from 'react'

import { cn } from '@/utilities/ui'

import { promotionBadgeBaseClassName } from './promotionBadgeStyles'

export type PromotionAvailableBadgeProps = {
  label: string
}

export function PromotionAvailableBadge({ label }: PromotionAvailableBadgeProps) {
  return (
    <span
      className={cn(
        promotionBadgeBaseClassName,
        'border-black/10 bg-[#FBCCFF] text-[#49225B] shadow-[0_6px_20px_rgba(9,114,82,0.12)]',
      )}
    >
      {label}
    </span>
  )
}
